export default {
  items: [],
  error: null,
  isLoading: false,
  message: '',
};
